export default "__VITE_ASSET__iU1Psz_s__"